<template>
  <mdb-container fluid>
    <DataTableCopyModal
      v-if="false"
      :modalshow="modalshow"
      :chainidlist="chainidlist"
      v-on:copyRetailers="copyRetailers"
    />
    <DataTableCopyModal
      v-if="false"
      :modalshow="modalshow"
      :chainidlist="chainidlist"
      v-on:copyRetailers="copyRetailers"
    />
    <mdb-row>
      <mdb-btn v-if="deleteEnabled" color="indigo" @click="archiveContent">
        Poista
      </mdb-btn>
      <mdb-btn v-if="delete2Enabled" color="indigo" @click="archiveContent2">
        Poista
      </mdb-btn>
      <mdb-btn
        v-if="retailerCopyEnabled"
        color="indigo"
        @click="copyRetailerContent"
      >
        Toimipaikkojen kopiointi
      </mdb-btn>
    </mdb-row>
    <mdb-row>
      <ag-grid-vue
        :style="'width:' + width + ';' + 'height:' + height + ';'"
        class="ag-theme-alpine"
        rowSelection="multiple"
        :animateRows="true"
        :pagination="true"
        :columnDefs="columns"
        :rowData="rows"
        :alwaysShowVerticalScroll="true"
        :enableFilter="filtering"
        @grid-ready="onGridReady"
        :rowHeight="rowHeight"
      />
    </mdb-row>
  </mdb-container>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { mdbBtn, mdbContainer, mdbRow } from "mdbvue";
import SimpleButtonGroup from "./SimpleButtonGroup.vue";
import SimpleImageComponent from "./SimpleImageComponent.vue";
import SimpleListComponent from "../components/SimpleListComponent.vue";
import DataTableCopyModal from "@/components/DataTableCopyModal.vue";

export default {
  name: "DataTableAG",
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    SimpleButtonGroup,
    // eslint-disable-next-line vue/no-unused-components
    SimpleImageComponent,
    // eslint-disable-next-line vue/no-unused-components
    SimpleListComponent,
    mdbBtn,
    mdbContainer,
    mdbRow,
    DataTableCopyModal,
  },
  data: () => ({
    loadReady: false,
    search: "",
    gridApi: null,
    gridColumnApi: null,
    rows: [],
    selectedIds: [],
    modalshow: false,
    retailercopycontentpath: "2.0/newbe/retailer/copy",
  }),
  props: {
    dataUpdate: {
      type: Number,
      default: 0,
    },
    deleteparam: String,
    columns: Array,
    getcontentpath: String,
    buttonList: Array,
    jsonobject: String,
    archiveparam: String,
    archivecontentpath: String,
    width: String,
    height: String,
    chainidlist: Array,
    image: Boolean,
    retailerCopyEnabled: {
      type: Boolean,
      default: false,
    },
    filtering: {
      type: Boolean,
      default: true,
    },
    rowHeight: {
      type: Number,
      default: 40,
    },
    deleteEnabled: {
      type: Boolean,
      default: false,
    },
    delete2Enabled: {
      type: Boolean,
      default: false,
    },
    archivecontentpath2: String,
    newBenefitCategoryId: Number,
  },
  methods: {
    copyRetailers(currentRetailerChainId, retailerName) {
      this.selectedIds = [];
      for (
        let i = 0, len = this.gridApi.getSelectedRows().length;
        i < len;
        i++
      ) {
        this.selectedIds.push(this.gridApi.getSelectedRows()[i].id);
      }
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        retailerids: this.selectedIds,
        retailerChainid: currentRetailerChainId,
        name: retailerName,
      });
      this.$http
        .post(this.retailercopycontentpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("copy_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.fetchData();
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("copy_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    archiveContent2() {
      for (
        let i = 0, len = this.gridApi.getSelectedRows().length;
        i < len;
        i++
      ) {
        this.selectedIds.push(this.gridApi.getSelectedRows()[i].id);
      }
      console.log(this.selectedIds);
      this.archiveModal = false;
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        [this.archiveparam]: this.selectedIds[0],
      });
      this.$http
        .post(this.archivecontentpath2, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("archive_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.fetchData();
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("archive_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.fetchData();
    },
    copyRetailerContent() {
      this.modalshow = !this.modalshow;
    },
    archiveContent() {
      for (
        let i = 0, len = this.gridApi.getSelectedRows().length;
        i < len;
        i++
      ) {
        this.selectedIds.push(this.gridApi.getSelectedRows()[i].id);
      }
      console.log(this.selectedIds);
      this.archiveModal = false;
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        [this.archiveparam]: this.selectedIds,
      });
      this.$http
        .post(this.archivecontentpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("archive_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.fetchData();
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("archive_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    deleteContent() {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        [this.deleteparam]: this.toBeArchivedIds,
      });

      this.$http
        .post(this.archivecontentpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.removeContent(response.data[this.archiveparam]);
            this.$notify.success({
              message: this.$t("archive_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("archive_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    fetchData() {
      if (this.columns[this.columns.length - 1].field === "action") {
        this.columns.pop();
      }
      this.columns.push({
        headerName: "Toiminto",
        field: "action",
        pinned: "left",
        width: 150,
        cellRenderer: "SimpleButtonGroup",
        cellRendererParams: {
          buttons: this.buttonList,
          clicked: function (id, button) {
            switch (button) {
              case 1:
                this.$emit(
                  "pressed-button1",
                  this.rows.find((element) => element.id === id)
                );
                break;
              case 2:
                this.$emit(
                  "pressed-button2",
                  this.rows.find((element) => element.id === id)
                );
                break;
              case 3:
                this.$emit(
                  "pressed-button3",
                  this.rows.find((element) => element.id === id)
                );
                break;
            }
          }.bind(this),
        },
      });
      /*}*/
      this.$notify.info({
        message: this.$t("fetching_content"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      var _self = this;
      this.$http
        .get(this.getcontentpath)
        .then((response) => {
          if (response.status == 200) {
            _self.rows = response.data[this.jsonobject];
            _self.rows.forEach((element) => {
              try {
                element.notificationdatetimes = "";
                element.notifications.forEach((notification) => {
                  element.notificationdatetimes =
                    element.notificationdatetimes + notification.due + ", ";
                });
                element.categorylist = "";
                element.categories.forEach((category) => {
                  element.categorylist =
                    element.categorylist + category.display + ", ";
                  if (category.id == _self.newBenefitCategoryId) {
                    element.newBenefit = 1;
                  } else {
                    element.newBenefit = 0;
                  }
                });
              } catch (error) {
                console.log(error);
              }
            });
            _self.gridApi.refreshCells();
            _self.$emit("load-ready");
          } else if (response.status == 401) {
            _self.$root.$emit("session_failed");
          } else {
            _self.$notify.error({
              message: _self.$t("content_not_loaded"),
              position: "top right",
              timeOut: _self.$store.state.notifytimeoutshort,
            });
          }
          _self.$notify.removeAll();
        })
        .catch((error) => {
          this.$notify.removeAll();
          this.$root.$emit("session_failed");
          return error;
        })
        .finally();
    },
  },
  watch: {
    dataUpdate() {
      if (this.dataUpdate > 0) {
        this.fetchData();
      }
    },
  },
};
</script>
